import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useCallback, useRef, useState } from "react";
import Anchor from "@/components/common/Anchor";
import Button from "@/components/common/Button";
import List from "@/components/common/List";
import { ButtonSize, ButtonVariant } from "@/constants/button";
import { useClickOutside } from "@/hooks/useClickOutside";
import { useTranslation } from "@/i18n/client";
import type { SecondaryNavLink } from "@/types/nav-bar";
import s from "./DropdownLinks.module.scss";

interface DropdownLinksProps {
  links: SecondaryNavLink[];
}

export default function DropdownLinks(props: DropdownLinksProps) {
  const { links } = props;
  const { t } = useTranslation("nav");
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleOpen = useCallback(() => {
    setOpen((prevOpen) => !prevOpen);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useClickOutside(wrapperRef, handleClose, open);

  return (
    <div ref={wrapperRef} className={s.wrapper}>
      <Button
        onClick={handleOpen}
        EndIcon={ArrowDropDownIcon}
        variant={ButtonVariant.Outlined}
        size={ButtonSize.Small}
        className={s.button}
      >
        {t("secondary-nav.dropdown-links.button.label")}
      </Button>
      {open && (
        <List
          items={links}
          renderItem={({ text, url, openInNewTab }) => (
            <Anchor
              href={url}
              openInNewTab={openInNewTab}
              onClick={handleClose}
            >
              {text}
            </Anchor>
          )}
          className={s.dropdown}
        />
      )}
    </div>
  );
}
